import { RoboAdvisorAPIData } from '../types'
import deepFreeze from '../objectDeepFreeze'

// Todo: data for fallback robos should live in a dedicated resource, not the frontend. follow up is needed to 1) determine what cases we want to show these robos for
// and if we're showing them correctly today and 2) for pulling this information behind an API so we don't unnecessarily expose them in the frontend
type FallbackRoboAdvisorData = {
    distance: string
    advisor: RoboAdvisorAPIData
}

type constantsType = {
    roboAdvisors: FallbackRoboAdvisorData[]
}

const constants: constantsType = {
  roboAdvisors: [{
    distance: '0 miles',
    advisor: {
      fallback: true,
      id: 'random0' as unknown as number,
      compensation: 'Varies',
      certifications: 'FINRA / SEC',
      cta_destination: 'https://betterment.evyy.net/c/367030/96536/2299',
      format: 'roboadvisor',
      expertises: '',
      cpcustomlink: 'https://smartasset.com/disclosures/fee-structure/383',
      cp_display_disclosure: 'true',
      name: 'Betterment',
      imageUrl: 'https://d31s10tn3clc14.cloudfront.net/imgs/falc/betterment_logo.png',
      network: {
        founded_in: '2008',
        description_html: 'Betterment was founded in 2008 with a mission to make people\'s lives better. Today, with billions of dollars under management and hundreds of thousands of happy customers, they are the largest independent online advisor.'
      }
    } as RoboAdvisorAPIData
  }, {
    distance: '1 mile',
    advisor: {
      fallback: true,
      id: 'random1' as unknown as number,
      compensation: 'Varies',
      certifications: 'FINRA / SEC',
      cta_destination: 'https://wealthsimple.sjv.io/c/367030/383890/5571?u=https%3A%2F%2Fwww.wealthsimple.com%2Fen-us%2Fsmartasset',
      format: 'roboadvisor',
      expertises: '',
      cpcustomlink: 'https://smartasset.com/disclosures/fee-structure/1177', // using Stash's cp link is expected behavior here
      cp_display_disclosure: 'true',
      name: 'Wealthsimple',
      imageUrl: 'https://d31s10tn3clc14.cloudfront.net/imgs/falc/RoboAdvisor/wealthsimple_logo.png',
      network: {
        founded_in: '2014',
        description_html: 'Wealthsimple was founded in 2014 to provide long-term investment management without the high fees and account minimums associated with traditional investment managers. They provide access to financial advisors who can help plan your financial milestones and answer questions you might have about your investments.'
      }
    } as RoboAdvisorAPIData
  }, {
    distance: '2 miles',
    advisor: {
      fallback: true,
      id: 'random2' as unknown as number,
      compensation: 'Varies',
      certifications: 'FINRA / SEC',
      cta_destination: 'https://stash-invest.pxf.io/c/367030/417036/4799',
      format: 'roboadvisor',
      expertises: '',
      cpcustomlink: 'https://smartasset.com/disclosures/fee-structure/1177',
      cp_display_disclosure: 'true',
      name: 'Stash',
      imageUrl: 'https://d31s10tn3clc14.cloudfront.net/imgs/falc/RoboAdvisor/stash_logo.png',
      network: {
        founded_in: '2015',
        description_html: 'Stash was founded in 2015 with the mission of empowering a new generation of investors. Their goal is to provide you with the choices, tools, and tips you need to build a portfolio that reflects who you are.'
      }
    } as RoboAdvisorAPIData
  }]
}

deepFreeze(constants)

export default constants
